//Material ui icons
import {
  Fastfood,
  Dashboard as DashboardIcon,
  RestaurantMenu,
  Receipt,
  People,
  SettingsApplications,
  Settings as SettingsIcon,
  GroupWork,
  MenuBook,
  PhotoLibrary,
  // ReceiptRounded,
  RedeemRounded as CouponIcon,
  Timeline as CouponAnalyticsIcon,
  ImportExport as BulkExportOrders,
} from "@material-ui/icons";
import SettingsOverscanIcon from '@material-ui/icons/SettingsOverscan';
export const listItems = [
  {
    pageURL: "/",
    text: "Live Orders",
    Icon: Fastfood,
    detect: "live_orders",
  },
  {
    pageURL: "/bulk-export-orders",
    text: "Bulk Export Orders",
    Icon: BulkExportOrders,
    detect: "bulk_export_order",
  },
  {
    pageURL: "/dashboard",
    text: "Dashboard",
    Icon: DashboardIcon,
    detect: "dashboard",
  },
  {
    pageURL: "/menu",
    text: "Add Item",
    Icon: RestaurantMenu,
    detect: "add_item",
  },
  {
    pageURL: "/menu-items",
    text: "Menu",
    Icon: MenuBook,
    detect: "menu",
  },
  {
    pageURL: "/coupons",
    text: "Coupons",
    Icon: CouponIcon,
    detect: "coupons",
  },
  {
    pageURL: "/coupon-analytics",
    text: "Coupon Analytics",
    Icon: CouponAnalyticsIcon,
    detect: "coupon_analytics",
  },
  // {
  //   pageURL: "/reviews",
  //   text: "Reviews",
  //   Icon: RateReview,
  // },
  {
    pageURL: "/invoices",
    text: "Invoices",
    Icon: Receipt,
    detect: "invoices",
  },
  {
    pageURL: "/customers",
    text: "Customers",
    Icon: People,
    detect: "customers",
  },
  {
    pageURL: "/theme",
    text: "Theme",
    Icon: SettingsApplications,
    detect: "theme",
  },
  {
    pageURL: "/settings",
    text: "Settings",
    Icon: SettingsIcon,
    detect: "settings",
  },
  {
    pageURL: "/image-library",
    text: "Image Library",
    Icon: PhotoLibrary,
    detect: "image_library",
  },
  {
    pageURL: "/version",
    text: "Version Control",
    Icon: SettingsOverscanIcon,
    detect: "version_control",
  },
];
